import React from 'react';
import classnames from 'classnames';
import {removeHtml} from "@nutastic/nutastic-react-app";
import Fade from 'react-reveal/Fade';

const ArticleBox = ({ className, content, contentLimit, image, isLarge, isSmall, isWide, lazyLoad, link, subtext, title }) => {
    const componentClass = 'article-box';
    const classes = classnames( className, componentClass,  {
        [`${componentClass}--wide`]: isWide,
        [`${componentClass}--large`]: isLarge,
        [`${componentClass}--small`]: isSmall && !isLarge
    });

    const getImage = () => {
        const imageStyle = { backgroundImage: image ? `url('${image}')` : 'url("/public/assets/img/meta-image.jpeg")' }
        const result = link
            ? <a href={link} className={`${componentClass}__image`} style={imageStyle} />
            : <div className={`${componentClass}__image`} style={imageStyle} />;
        return lazyLoad ? <Fade>{ result }</Fade> : result;
    }

    const getContentSubstring = () => content.length > contentLimit
        ? `${content.substring(0, contentLimit)}...`
        : content.substring(0, contentLimit);

    const getTitle = () => {
        return link ? <h4><a href={link} className={`${componentClass}__titleLink`}>{ title }</a></h4> : <h4>{ title }</h4>
    }

    return <div className={classes}>
        { image && getImage() }
        <div className={`${componentClass}__content`}>
            { title && getTitle() }
            <div className="excerpt">{ removeHtml(contentLimit ? getContentSubstring() : content) }</div>
            {!isWide &&
            <div className="box-footer">
                { subtext && <div><span>{ subtext }</span></div> }
                { link
                    ? <a href={link}><i className="ion-ios-arrow-round-forward"/></a>
                    : <span>&nbsp;</span>
                }
            </div>
            }
        </div>
    </div>
};

export default ArticleBox;
